import { useAuth0 } from "@auth0/auth0-react";

import MessageBlock from "components/organisms/MessageBlock";

const Welcome = () => {
  const { logout } = useAuth0();

  const handleGoToSignIn = () =>
    logout({ logoutParams: { returnTo: window.location.origin } });

  return (
    <MessageBlock
      headline="Welcome"
      content="You've successfully signed up. Please check your inbox and verify your email before signing in."
      onClick={handleGoToSignIn}
      buttonLabel="Go to Sign In"
    />
  );
};

export default Welcome;
